var mode = 1; //开发模式,0是开发环境,连接测试接口;1是生产环境,连接正式接口
var apiUrl = ''
var company = '北京府右控股集团有限公司'; //管理后台框架页面的项目名称;分别是左上角和底部,另外前台页面的title需要再index.html单独设置
var copyrightYear = new Date().getFullYear();
var ossUrl = 'http://ycuauto.hi531.com/oss/';
var ossUrlCallBack = 'https://haizhiyou-app.oss-cn-qingdao.aliyuncs.com/';

function test(){
	//window.alert(123);
}

if(mode == 0) {
	apiUrl = 'http://127.0.0.1:8080/fulright/api';
}else if(mode == 1) {
	var host = window.location.host.indexOf('8080') > 1 ? window.location.host : window.location.host.replace(/8020/g, '8080');
	apiUrl = window.location.protocol + '//' + host + '/fulright/api';
}


export default{
	apiUrl,
	company,
	copyrightYear,
	ossUrl,
	ossUrlCallBack,
	test
}